import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { firebaseAuth } from "../firebase/auth";
import { DEFAULT_DASHBOARD_PATH, isDashboardPath } from "../../views/dashboard/dashboardRoutes";
import MenuDrawer from "./MenuDrawer";
import logo from "../../static/logoWhite.png";
import "./Header.css";

const routeNames: Record<string, string> = {
  "/": "Dashboard",
  "/dashboard": "Dashboard",
  "/sweden": "Dashboard",
  "/farms": "Gårdar",
  "/grows": "Odlingar",
  "/devices": "Enheter",
  "/plants": "Plantor",
  "/products": "Produkter",
  "/batches": "Batcher",
  "/labels": "Etiketter",
};

export default function Header() {
  const [user, loading] = useAuthState(firebaseAuth);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const sectionName = routeNames[location.pathname] || (isDashboardPath(location.pathname) ? "Dashboard" : location.pathname.startsWith("/owner") ? "Ägarverktyg" : "");

  useEffect(() => { setIsDrawerOpen(false); }, [location.pathname]);

  return <>
    <header className="Header">
      <div className="HeaderInner">
        <button className="HeaderBrand" type="button" onClick={() => navigate(DEFAULT_DASHBOARD_PATH)} aria-label="VERT.farm, gå till dashboard">
          <span className="HeaderBrandMark"><img src={logo} alt="" /></span>
          <span className="HeaderBrandName">VERT<span>.farm</span></span>
        </button>
        {sectionName && <div className="HeaderLocation"><span className="HeaderLocationDivider" /><span>Arbetsyta</span><strong>{sectionName}</strong></div>}
        {user && !loading && <button className="HeaderMenuButton" type="button" onClick={() => setIsDrawerOpen(true)} aria-label="Öppna huvudmeny" aria-expanded={isDrawerOpen} aria-controls="app-navigation">
          <span>Meny</span><MenuIcon fontSize="small" />
        </button>}
      </div>
    </header>
    <Drawer anchor="right" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} PaperProps={{ id: "app-navigation", className: "MenuDrawerPaper" }}>
      <div className="MenuDrawerTop"><span>Huvudmeny</span><button type="button" onClick={() => setIsDrawerOpen(false)} aria-label="Stäng huvudmeny"><CloseIcon fontSize="small" /></button></div>
      <MenuDrawer setIsDrawerOpen={setIsDrawerOpen} />
    </Drawer>
  </>;
}
